import { useCallback, useEffect, useState } from "react"
import { Stack, Pagination } from "@mui/material"
import { createPortal } from "react-dom"
import FormButton from "../FormButton"
import Input from "../Input"
import Div from "../Div"
import { getSupportTicketStatusList } from "../../http/CentralizedDataHttp"


export default function GetSupportTicketModal({ handleClicked, domain_name, ...props }) {

    const [domainList, setDomainList] = useState()
    const [initialDomainList, setInitialDomainList] = useState()

    const [search, setSearch] = useState('')

    const [currentPage, setCurrentPage] = useState(1);

    const itemsPerPage = 15;

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    const currentItems = domainList ? domainList.slice(indexOfFirstItem, indexOfLastItem) : null;

    // Calculate total pages
    const totalPages = domainList ? Math.ceil(domainList.length / itemsPerPage) : null;

    // Change page
    const paginate = (event, value) => {
        setCurrentPage(value);
    };

    const getCurrentRenewalDomain = useCallback(async () => {

        const response = await getSupportTicketStatusList(domain_name)
        console.log(response)
        setDomainList(response.tickets)
        setInitialDomainList(response.tickets)

    }, [domain_name])

    useEffect(() => {

        getCurrentRenewalDomain()

    }, [getCurrentRenewalDomain])

    function handleClose() {
        handleClicked(false);
    }

    function handleSearchCustomer(event) {

        const search_item = event.target.value;

        console.log(search_item)
        const filteredList = initialDomainList.filter((customer) => {

            if ((customer && customer.customerDomain)) {

                return customer.customerDomain.toLowerCase().includes(search_item.toLowerCase());
            }
            else {
                return false
            }
        });
        setDomainList(filteredList);
        setSearch(search_item)

    }

    return <>
        {
            createPortal(
                <Div className="modal-backdrop">
                    <dialog {...props} style={{ zIndex: '1', width: '90%', overflow: 'scroll' }}>

                        <Div className="form-group" style={{marginLeft:'15px'}}>
                           Tickets are {domain_name}
                        </Div>
                        <Div className='row'>

                        <Div className="toolbar-item col-sm-5" role="group" style={{marginLeft:'15px'}} >

                            <Input type='text' name='text' id='text' value={search}
                                onChange={handleSearchCustomer}
                            />

                        </Div>
                        </Div>

                        <Div className='col-md-12 margin_top'>
                            {domainList ?
                                <>
                                    <table className="table" border="1">
                                        <thead>
                                            <tr>
                                                <th>Ticket Id</th>
                                                <th>Subject</th>
                                                <th>Email</th>
                                                <th>Status</th>
                                                <th>Created At</th>
                                            
                                            </tr>
                                        </thead>
                                        <tbody id="tableBody">
                                            {currentItems.map((ticket) =>
                                                <>
                                                    <tr key={ticket.ticket_id}>
                                                        <td>
                                                            {ticket.ticketNumber}
                                                        </td>
                                                        <td>{ticket.subject}</td>
                                                        <td>{ticket.email}</td>
                                                        <td>{ticket.status}</td>
                                                        <td>{ticket.created_at}</td>
                                                      

                                                    </tr>
                                                </>
                                            
                                            )

                                            }
                                        </tbody>
                                    </table>
                                    {domainList.length > 0 ?
                                        <Stack spacing={2}>
                                            <Pagination count={totalPages} color="primary" page={currentPage} onChange={paginate}>

                                            </Pagination>

                                        </Stack> : null
                                    }
                                </>
                                : null}
                        </Div>
                        <Div className="form-group">
                            <Div className='row'>
                                <Div className='col-sm-9'>
                                </Div>
                                <Div className='col-sm-2'>
                                    <FormButton type='button' onClick={handleClose} style={{ margin: '2px' }} className="btn btn-primary submit-btn btn-block" >Close</FormButton>
                                </Div>
                            </Div>

                        </Div>

                    </dialog>

                </Div>
                , document.getElementById('modal'))

        }
    </>
}